var _path, _polygon, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-63"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.9,
    y: 56.13,
    width: 101.57,
    height: 105.87,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.02,
    y: 56.13,
    width: 101.57,
    height: 105.87,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.62,162H46V56.1H147.62ZM46.05,162H147.56V56.17H46.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.67,
    y: 70.37,
    width: 74.26,
    height: 77.41,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.67,148.29a11.66,11.66,0,0,1-1.83,2.13c-1.18,1.25-2.85,3-4.72,4.79s-3.58,3.48-4.85,4.64a12.21,12.21,0,0,1-2.15,1.79A11.84,11.84,0,0,1,48,159.52c1.18-1.25,2.85-3,4.73-4.8s3.59-3.49,4.86-4.65A12.05,12.05,0,0,1,59.67,148.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.93,148.1a12.2,12.2,0,0,1,2.13,1.83c1.26,1.19,2.95,2.86,4.79,4.72s3.48,3.59,4.64,4.86a11.32,11.32,0,0,1,1.79,2.14,11.88,11.88,0,0,1-2.12-1.82c-1.25-1.19-2.95-2.86-4.8-4.73s-3.48-3.6-4.65-4.86A11.86,11.86,0,0,1,133.93,148.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.73,70.57a12.2,12.2,0,0,1,1.83-2.13c1.19-1.25,2.86-2.94,4.72-4.78s3.59-3.48,4.86-4.65a11.47,11.47,0,0,1,2.14-1.78,11.88,11.88,0,0,1-1.82,2.12c-1.19,1.25-2.86,2.95-4.73,4.79s-3.6,3.49-4.86,4.66A11.48,11.48,0,0,1,133.73,70.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.47,70.76a11.66,11.66,0,0,1-2.13-1.83c-1.25-1.18-2.94-2.85-4.78-4.72s-3.48-3.58-4.65-4.85a12.21,12.21,0,0,1-1.79-2.15A12.07,12.07,0,0,1,48.25,59c1.25,1.18,3,2.85,4.79,4.73s3.49,3.59,4.65,4.86A11.13,11.13,0,0,1,59.47,70.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.73,147.78s0-.14,0-.38,0-.62,0-1.08c0-1,0-2.37,0-4.18,0-3.67,0-9-.08-15.78,0-13.55-.08-32.87-.15-56l.29.28-74,0h0l.32-.33c0,28.41,0,55,0,77.41l-.28-.29,53.62.15,15.06.07,4,0,1,0,.36,0h-.33l-1,0-3.93,0-15,.07-53.8.15h-.29v-.28c0-22.42,0-49,0-77.41V70h.33l74,0H134v.29c-.06,23.2-.11,42.58-.15,56.18,0,6.74-.06,12.06-.07,15.71,0,1.79,0,3.17,0,4.12,0,.45,0,.8,0,1.05A2.21,2.21,0,0,1,133.73,147.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.41,
    y: 96.68,
    width: 24.78,
    height: 24.78,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.05,
    y: 58.08,
    width: 9.81,
    height: 48.83,
    transform: "translate(-0.44 2.11) rotate(-0.31)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.97,
    y: 58.25,
    width: 25.41,
    height: 26.96,
    transform: "translate(-0.38 1.7) rotate(-0.31)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.27,
    y: 58.11,
    width: 25.42,
    height: 26.96,
    transform: "translate(-0.38 1.84) rotate(-0.31)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.94,65.76q25.33.21,50.71-.23a.27.27,0,0,0,0-.54c-16.89-.09-33.83,0-50.71.31a.23.23,0,0,0,0,.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.11,
    y: 84.82,
    width: 46.17,
    height: 21.97,
    transform: "translate(-0.51 1.67) rotate(-0.31)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.07,
    y: 84.57,
    width: 46.17,
    height: 21.97,
    transform: "translate(-0.51 1.92) rotate(-0.31)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.09,91.05c30.67.35,61.45,0,92.13-.46a.27.27,0,0,0,0-.54c-30.67-.16-61.46-.14-92.13.54a.23.23,0,0,0,0,.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.82,
    y: 106.91,
    width: 178.89,
    height: 7.87,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.11,
    y: 110.69,
    width: 7.26,
    height: 15.8,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.52,
    y: 110.69,
    width: 7.26,
    height: 15.8,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.68,
    y: 39.87,
    width: 9.81,
    height: 67.16,
    transform: "translate(-0.39 2.17) rotate(-0.31)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.54,
    y: 52.39,
    width: 15.25,
    height: 54.43,
    transform: "translate(-0.42 2.24) rotate(-0.31)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.54,62.83a53.82,53.82,0,0,1-7.62.27,54,54,0,0,1-7.63-.27,111.94,111.94,0,0,1,15.25,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.54,60.55a56.75,56.75,0,0,1-7.62.26,57,57,0,0,1-7.63-.26,107.8,107.8,0,0,1,15.25,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.54,98.59a111.94,111.94,0,0,1-15.25,0,107.8,107.8,0,0,1,15.25,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.54,96.3a111.94,111.94,0,0,1-15.25,0,111.94,111.94,0,0,1,15.25,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.17,91.31c-.15,0-.27-5.49-.27-12.26s.12-12.27.27-12.27.26,5.49.26,12.27S417.31,91.31,417.17,91.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.71,
    y: 65.71,
    width: 16.6,
    height: 41.08,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.08,51.31a2.82,2.82,0,1,1-2.82-2.82A2.82,2.82,0,0,1,407.08,51.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.39,
    y: 59.07,
    width: 1.74,
    height: 39.95,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.13,151.9a30.22,30.22,0,0,1,6.65-4.43l.21-7.4,12-2.37,3,6.77a30.07,30.07,0,0,1,7.84,1.57l5.38-5.09,10.18,6.83-2.67,6.91a29.76,29.76,0,0,1,4.43,6.65l7.41.21,2.37,12-6.78,3a30,30,0,0,1-1.56,7.83l5.08,5.38L448.88,200,442,197.31a30,30,0,0,1-6.66,4.43l-.2,7.4-12,2.37-3-6.77a30.07,30.07,0,0,1-7.84-1.57l-5.38,5.09-10.18-6.83,2.67-6.91a29.76,29.76,0,0,1-4.43-6.65l-7.41-.21-2.37-12,6.77-3a30.41,30.41,0,0,1,1.57-7.83l-5.08-5.38,6.82-10.18,6.91,2.66Zm9.31,14.92a13.15,13.15,0,1,0,18.24-3.6A13.15,13.15,0,0,0,411.44,166.82Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.88,147.11a14.5,14.5,0,0,1,3.62-1.57l.74-3.58,6.05-.11.87,3.55a14.62,14.62,0,0,1,3.67,1.45l3.06-2,4.36,4.21-1.9,3.12a14.66,14.66,0,0,1,1.57,3.62l3.58.75.11,6.05-3.55.87a15.33,15.33,0,0,1-1.45,3.67l2,3.06-4.21,4.35-3.12-1.9a15.07,15.07,0,0,1-3.62,1.58l-.75,3.58-6.05.1-.87-3.55a14.89,14.89,0,0,1-3.67-1.44l-3.06,2-4.35-4.2,1.9-3.13a14.53,14.53,0,0,1-1.58-3.62l-3.58-.74-.1-6.05,3.55-.87a14.59,14.59,0,0,1,1.44-3.67l-2-3.06,4.2-4.36,3.13,1.9Zm3.22,8.06a6.49,6.49,0,1,0,9.18-.16A6.49,6.49,0,0,0,350.1,155.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.1,155.17a4.87,4.87,0,0,1,1.21-1.06,6.48,6.48,0,0,1,4.24-1,6.55,6.55,0,0,1,2.88,1,6.68,6.68,0,0,1,2.32,2.62,6,6,0,0,1,.59,1.82,6.09,6.09,0,0,1,0,2,6.64,6.64,0,0,1-1.8,3.75,6.71,6.71,0,0,1-3.68,1.93,6.11,6.11,0,0,1-2,0,6.29,6.29,0,0,1-1.84-.52,6.59,6.59,0,0,1-2.7-2.24,6.52,6.52,0,0,1-.27-7.11,5.09,5.09,0,0,1,1-1.24s-.39.43-.89,1.32a6.5,6.5,0,0,0-.72,4.15,6.37,6.37,0,0,0,3.71,4.8,6,6,0,0,0,1.75.49,5.72,5.72,0,0,0,1.89,0,6.28,6.28,0,0,0,5.18-5.37,6,6,0,0,0,0-1.89,5.92,5.92,0,0,0-.54-1.73,6.42,6.42,0,0,0-9.06-2.67C350.52,154.76,350.14,155.2,350.1,155.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.88,147.11l-.2-.11-.6-.34-2.36-1.4h.07l-4.17,4.37v-.11l2,3,0,.05,0,.06a14.53,14.53,0,0,0-1.42,3.65l0,.07h-.07l-3.55.89.1-.14q.06,2.86.12,6.05l-.12-.14,3.59.74.09,0,0,.09A14.65,14.65,0,0,0,342,167.5l.05.08-.05.08-1.89,3.13,0-.2,4.35,4.2-.21,0,3.06-2,.08-.06.1.05a14.85,14.85,0,0,0,3.63,1.43l.1,0,0,.11.87,3.55-.18-.14,6.05-.11-.18.15c.24-1.13.49-2.35.75-3.58l0-.11.11,0a15,15,0,0,0,3.57-1.55h0l.1,0,.09,0,3.13,1.9-.23,0,4.2-4.35,0,.23-2-3.06-.06-.1.05-.09a14.44,14.44,0,0,0,1.43-3.63l0-.1.1,0,3.56-.87-.14.18c0-2.07-.07-4.08-.1-6.05l.14.16-3.58-.75-.1,0,0-.09a14.6,14.6,0,0,0-1.55-3.59l0-.08,0-.08,1.9-3.12,0,.19-4.35-4.22.18,0-3.06,2-.07,0-.07,0a14.81,14.81,0,0,0-3.64-1.44l-.07,0,0-.07c-.31-1.29-.59-2.45-.85-3.55l.1.08-6.05.08.08-.07c-.3,1.43-.55,2.6-.76,3.58v0h0a15.13,15.13,0,0,0-2.76,1.07l-.65.34-.22.11a1.72,1.72,0,0,1,.2-.14l.64-.37a14.91,14.91,0,0,1,2.76-1.12l0,0c.2-1,.43-2.15.72-3.58v-.07h.07l6.05-.13h.09l0,.08c.27,1.1.56,2.26.88,3.55l-.09-.09a14.91,14.91,0,0,1,3.71,1.45h-.14l3.05-2,.1-.06.08.08,4.36,4.19.09.09-.06.11c-.62,1-1.24,2.05-1.89,3.12v-.16a15,15,0,0,1,1.59,3.65l-.12-.11,3.58.74.13,0v.13q.06,3,.12,6.05v.14l-.14,0-3.55.87.13-.13a14.76,14.76,0,0,1-1.46,3.72V167l2,3.05.08.13-.1.1-4.2,4.36-.11.1-.12-.07-3.13-1.9h.19a14.47,14.47,0,0,1-3.66,1.59l.13-.14c-.25,1.23-.51,2.45-.74,3.58l0,.15h-.15l-6.05.1h-.15l0-.14c-.3-1.23-.6-2.44-.87-3.56l.13.13a15,15,0,0,1-3.71-1.46h.18l-3.06,2-.12.08-.1-.1-4.34-4.2-.1-.1.07-.11,1.9-3.12v.16A14.69,14.69,0,0,1,340.1,164l.11.11-3.58-.75-.11,0v-.12c0-2.12-.07-4.15-.1-6.05v-.11l.11,0,3.55-.86-.09.09a15,15,0,0,1,1.47-3.7v.12l-2-3.07,0-.06.05-.06,4.23-4.33,0,0,0,0,2.31,1.44.59.37A1.72,1.72,0,0,1,346.88,147.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.87,328.1h0l-20.64-3.17v0l-.89-12.57a51.08,51.08,0,0,1-11.61-7l-11.56,5v0l-12.36-16.84h0l8.25-9.51a51,51,0,0,1-3.23-13.19l-11.74-4.62v0l3.17-20.64h0l12.56-.89a51.34,51.34,0,0,1,7-11.61l-5-11.56h0l16.84-12.36,0,0,9.5,8.25a51.43,51.43,0,0,1,13.19-3.23L366,202.37h0l20.64,3.17v0l.89,12.56a51.26,51.26,0,0,1,11.61,7l11.57-5h0L423.12,237v0l-8.25,9.5a51.1,51.1,0,0,1,3.22,13.19l11.74,4.62v0L426.65,285h0l-12.57.88a51.23,51.23,0,0,1-7,11.61l5,11.57h0L395.2,321.4h0l-9.51-8.25a51,51,0,0,1-13.19,3.22Zm-20.61-3.22,20.58,3.17,4.62-11.73h0a50.76,50.76,0,0,0,13.21-3.23h0l9.51,8.25L412,309l-5-11.55v0a51,51,0,0,0,7-11.62v0h0l12.56-.88,3.16-20.58L418,259.73v0a50.79,50.79,0,0,0-3.23-13.2v0h0l8.25-9.5-12.32-16.79-11.55,5h0a51.15,51.15,0,0,0-11.62-7.05h0v0l-.88-12.56-20.59-3.16-4.61,11.73h0a51.5,51.5,0,0,0-13.2,3.23h0l-9.5-8.25-16.79,12.32,5,11.55h0a50.72,50.72,0,0,0-7.05,11.63h0l-12.56.89-3.16,20.58,11.73,4.62h0A51.27,51.27,0,0,0,319.1,284h0v0l-8.25,9.5,12.32,16.78,11.55-5h0a51,51,0,0,0,11.63,7h0Zm20.48-37.8a23.16,23.16,0,0,1-3.42-.26,22.4,22.4,0,1,1,14.88-41.39,22.37,22.37,0,0,1,10.66,22.64,22.39,22.39,0,0,1-17,18.4A21.93,21.93,0,0,1,367.74,287.08Zm-13.26-40.45v0A22.38,22.38,0,0,0,346,269.84a22.38,22.38,0,0,0,26.93,16.59,22.36,22.36,0,1,0-18.4-39.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.48,246.63a16.82,16.82,0,0,1,4.72-2.9A22.61,22.61,0,0,1,383.36,248a22.94,22.94,0,0,1,6.38,10.27,22.76,22.76,0,0,1-.1,13.34,22.83,22.83,0,0,1-21.93,16.1,21.75,21.75,0,0,1-6.81-1.05,21.43,21.43,0,0,1-5.95-2.87,22.89,22.89,0,0,1-7.88-9.16,22.61,22.61,0,0,1-2.16-10.31,22.34,22.34,0,0,1,5.38-14,17.07,17.07,0,0,1,4.19-3.64c.1.12-1.58,1.22-3.8,4a22.33,22.33,0,0,0-4.86,13.71,21.84,21.84,0,0,0,9.79,18.47,21.78,21.78,0,0,0,12.11,3.64,21.66,21.66,0,0,0,20.72-15.21,20.2,20.2,0,0,0,1-6.44,20.88,20.88,0,0,0-.85-6.2,22,22,0,0,0-6-9.83,21.71,21.71,0,0,0-8.71-5.05,22.3,22.3,0,0,0-14.53.52A53.85,53.85,0,0,0,354.48,246.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.22,217.36a4.07,4.07,0,0,1-.63-.48l-1.83-1.53-7.2-6.1h.26L322.07,221.7l.11-.39,5.07,11.54.09.2-.14.18a50.68,50.68,0,0,0-6.95,11.57l-.11.23-.25,0-12.58.92.42-.38c-1,6.49-2,13.38-3.12,20.62l-.31-.54L316,270.26l.3.12,0,.32a50.93,50.93,0,0,0,3.22,13.07l.13.31-.22.25-8.25,9.53,0-.71L323.64,310l-.72-.19,11.55-5,.34-.15.29.23a50.65,50.65,0,0,0,11.5,7l.34.15,0,.37c.28,3.94.58,8.24.89,12.58l-.53-.58L368,327.44l-.69.4c1.46-3.71,3-7.71,4.62-11.73l.14-.37.39,0a50.51,50.51,0,0,0,13-3.19h0l.37-.14.29.25,9.51,8.27-.79,0,16.82-12.33-.21.76-5-11.56-.15-.35.24-.3a50.54,50.54,0,0,0,7-11.48l.15-.35.37,0,12.58-.88-.56.52q1.64-10.56,3.19-20.62l.36.64-11.72-4.64-.33-.12,0-.35a50.91,50.91,0,0,0-3.18-13.07l-.12-.31.22-.26,8.28-9.5,0,.67-12.31-16.85.59.16-11.57,5-.25.11-.22-.17a50.67,50.67,0,0,0-11.51-7l-.24-.11v-.25c-.31-4.57-.59-8.69-.85-12.58l.32.35L366,202.68l.31-.18c-1.88,4.67-3.42,8.51-4.7,11.7l-.05.12h-.12a52.26,52.26,0,0,0-10,2l-2.41.77a5,5,0,0,1-.8.25A4.93,4.93,0,0,1,349,217c.52-.21,1.31-.52,2.38-.88a49.79,49.79,0,0,1,10.05-2.21l-.17.13c1.24-3.21,2.73-7.06,4.54-11.76l.08-.22.23,0,20.64,3.08.29,0,0,.3c.29,3.89.59,8,.93,12.58l-.25-.36a51.81,51.81,0,0,1,11.75,7.08l-.47-.07,11.54-5,.36-.16.23.32,12.38,16.79.25.35-.28.32-8.24,9.53.09-.57a51.88,51.88,0,0,1,3.29,13.36l-.36-.48L430,263.78l.44.17-.08.47q-1.53,10.06-3.14,20.62l-.07.49-.49,0-12.58.9.52-.37a51.54,51.54,0,0,1-7.12,11.77l.09-.64q2.49,5.71,5,11.55l.2.47-.41.3-16.82,12.35-.41.3-.38-.34q-4.73-4.1-9.52-8.26l.65.11h0A51.8,51.8,0,0,1,372.54,317l.53-.41c-1.59,4-3.16,8-4.62,11.74l-.19.47-.5-.08-20.62-3.17-.5-.08,0-.5c-.31-4.34-.61-8.64-.88-12.58l.37.52a51.55,51.55,0,0,1-11.77-7.14l.63.09-11.57,5L323,311l-.29-.38c-4.27-5.85-8.45-11.55-12.32-16.84l-.27-.37.3-.34,8.28-9.5-.1.56a51.87,51.87,0,0,1-3.24-13.36l.33.44-11.72-4.64-.38-.15.06-.4c1.13-7.23,2.21-14.12,3.22-20.61l.05-.37.37,0,12.58-.85-.36.25a51.8,51.8,0,0,1,7.14-11.7l-.05.39-5-11.58-.1-.24.21-.15,16.89-12.25.13-.1.12.11,7,6.21,1.8,1.63A6.81,6.81,0,0,1,348.22,217.36Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M449.57,366.43a91.17,91.17,0,0,0,1.81-20.32c-.13-6.76-1.61-13.61-5.16-19.35a33.63,33.63,0,0,0-5.12,20.93,30.93,30.93,0,0,0,8.16,19",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.86,384.51c.09-7.27,0-14.62-1.69-21.68s-5.26-13.9-11-18.33a38.27,38.27,0,0,0,.61,22.74c2.51,7.29,5.87,12.73,12.1,17.27",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.84,406c1-6.5,1.78-13.08,1.08-19.61s-3-13.06-7.67-17.72a34.58,34.58,0,0,0-2.17,20.43c1.38,6.81,3.73,12.09,8.76,16.9",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.83,421.36c-.35-7.38-.87-14.82-3.05-21.87s-6.19-13.77-12.31-17.9a38.74,38.74,0,0,0,2,23c3,7.23,6.74,12.54,13.32,16.76",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.91,439.48c.23-6.77.33-13.61-1.13-20.22s-4.61-13.05-9.89-17.29a35.66,35.66,0,0,0,.11,21.18c2.19,6.84,5.21,12,10.91,16.33",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,455c.24-6.77.33-13.61-1.12-20.22s-3.87-12.42-9.14-16.66c-2.12,6.85-2.83,13.72-.64,20.55s5.2,12,10.9,16.33",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.89,384.31a70.22,70.22,0,0,1,14.65-7.53,57.16,57.16,0,0,1,12.54-3.38,23.18,23.18,0,0,1,12.73,1.7,37.39,37.39,0,0,1-39.92,9.21",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.89,439.6a57.17,57.17,0,0,1,11.92-6.13,46.35,46.35,0,0,1,10.2-2.75,18.87,18.87,0,0,1,10.35,1.38,30.43,30.43,0,0,1-32.47,7.5",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.12,451.91c4-1.56,9.37-4.78,13.63-5.32a46.61,46.61,0,0,1,10.55-.42,18.91,18.91,0,0,1,9.79,3.66,30.68,30.68,0,0,1-16.65,5c-5.88,0-12.4.28-17.32-2.93",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.47,404.66a69.81,69.81,0,0,1,14.66-7.53,57,57,0,0,1,12.53-3.39,23.26,23.26,0,0,1,12.73,1.71,37.44,37.44,0,0,1-39.92,9.21",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.79,426.58a70.12,70.12,0,0,1,13.59-9.32,56.75,56.75,0,0,1,12-4.93,23.16,23.16,0,0,1,12.84.08,37.39,37.39,0,0,1-38.44,14.17",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.63,368.69A46.76,46.76,0,0,0,485.15,346c-5.49.69-11,2-15.78,4.73-8,4.63-13.35,12.43-20.74,18",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457,351.69a24.66,24.66,0,0,0,12.63-30.35A30.61,30.61,0,0,0,457,352",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.07,456.25a3,3,0,0,1,.19-.31c.14-.23.34-.52.58-.89.55-.8,1.32-1.94,2.3-3.39s2.23-3.26,3.59-5.38,3-4.5,4.64-7.21,3.54-5.63,5.44-8.84,3.93-6.65,6-10.29c4.14-7.3,8.59-15.39,13-24,8.92-17.22,16.4-33.1,21.77-44.61L463,337.69c.75-1.58,1.33-2.83,1.74-3.7.19-.4.34-.72.46-1s.17-.32.17-.32a1.55,1.55,0,0,1-.12.34c-.1.25-.24.57-.42,1l-1.64,3.75c-1.44,3.24-3.54,7.94-6.19,13.71-5.28,11.56-12.72,27.47-21.64,44.7-4.45,8.61-8.91,16.7-13.09,24-2.11,3.63-4.11,7.09-6.07,10.27s-3.79,6.14-5.5,8.82-3.31,5.07-4.71,7.17-2.63,3.89-3.67,5.34l-2.37,3.33-.63.86C399.16,456.16,399.08,456.26,399.07,456.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.22,389.51a86.32,86.32,0,0,1-5.85-18.23,35.86,35.86,0,0,1,.72-18.79,31.53,31.53,0,0,1,9,18.11,29,29,0,0,1-3.56,19",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.94,404.27c-1.59-6.64-3-13.38-2.94-20.21s2-13.81,6.31-19.06A35.91,35.91,0,0,1,73.44,386c-.79,7.19-2.74,12.87-7.5,18.32",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.47,421.69c-2.21-5.75-4.33-11.61-5-17.73s.09-12.59,3.36-17.81A32.38,32.38,0,0,1,85,404.41c.15,6.52-.92,11.84-4.53,17.28",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,434.07c-1.2-6.82-2.26-13.75-1.72-20.66s2.82-13.88,7.57-18.93A36.48,36.48,0,0,1,99.71,416c-1.25,7.23-3.58,12.87-8.74,18.09",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.64,448.2c-1.62-6.15-3.12-12.4-3.15-18.75s1.53-12.9,5.48-17.87A33.41,33.41,0,0,1,112.25,431c-.59,6.7-2.3,12-6.61,17.2",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.87,404.09a65.68,65.68,0,0,0-15-3.87,53.46,53.46,0,0,0-12.18-.51,21.8,21.8,0,0,0-11.3,4.19,35.09,35.09,0,0,0,38.45.19",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.68,448.3a53.35,53.35,0,0,0-12.18-3.14,43.31,43.31,0,0,0-9.91-.42,17.6,17.6,0,0,0-9.19,3.41,28.55,28.55,0,0,0,31.28.15",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7,420.77a65.74,65.74,0,0,0-15-3.86,53.35,53.35,0,0,0-12.17-.51,21.79,21.79,0,0,0-11.3,4.18,35.09,35.09,0,0,0,38.45.19",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.83,438.22a65.71,65.71,0,0,0-14.36-5.72,54.09,54.09,0,0,0-12-2,21.83,21.83,0,0,0-11.74,2.73,35.1,35.1,0,0,0,38.12,5",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.56,391.39a43.91,43.91,0,0,1-38.13-13.24,39.05,39.05,0,0,1,15.42,1.07c8.28,2.58,14.79,8.62,22.71,12.17",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.41,377.54a23.13,23.13,0,0,1-17.84-25.17A28.7,28.7,0,0,1,44.43,377.8",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.17,452.15a1.41,1.41,0,0,1-.24-.2l-.66-.61L105.78,449c-1.08-1-2.4-2.32-3.89-3.84s-3.22-3.21-5-5.16c-7.44-7.71-17.36-18.7-27.77-31.3s-19.46-24.32-25.93-32.85c-3.24-4.27-5.83-7.74-7.61-10.14l-2-2.78-.52-.73a1.05,1.05,0,0,1-.16-.26l.2.22.56.7,2.12,2.72c1.85,2.4,4.49,5.83,7.75,10,6.54,8.48,15.62,20.16,26,32.74s20.27,23.62,27.63,31.39c1.82,2,3.53,3.68,5,5.21s2.76,2.83,3.82,3.89l2.43,2.46.62.64Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.62,456.25,416.29,322.1a18.23,18.23,0,0,0-17.79-20L257.41,299.3a18.24,18.24,0,0,0-18.55,16.77L228.05,456.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.6,456.22a2.58,2.58,0,0,0,.08-.47c0-.34.09-.8.16-1.4.13-1.25.33-3.05.57-5.36.47-4.68,1.15-11.41,2-19.72,1.63-16.69,3.88-39.69,6.36-65.1,1.89-19.8,3.65-38.13,5.07-53.05h0q0-1.12-.06-2.22a8.93,8.93,0,0,0-.23-2.18,6.69,6.69,0,0,0-2.33-3.51,6.6,6.6,0,0,0-3.76-1.38l-3.71-.07-12.37-.19-7.91-.1h-2.07c-.47,0-.71,0-.71,0s.24,0,.71.05l2.07.08,7.91.22,12.36.3,3.7.1a6.17,6.17,0,0,1,5.68,4.6,8.38,8.38,0,0,1,.21,2.09c0,.72,0,1.45.05,2.19v0c-1.45,14.92-3.24,33.25-5.17,53.05-2.42,25.41-4.61,48.42-6.19,65.11-.77,8.32-1.39,15-1.82,19.74-.2,2.31-.35,4.12-.46,5.37-.05.6-.08,1.06-.11,1.4A3.47,3.47,0,0,0,383.6,456.22Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.65,221.24A6.52,6.52,0,0,0,221,219.6l.19,0a4.85,4.85,0,0,0-.55-.08,2.57,2.57,0,0,0-2,.29h0a4.77,4.77,0,0,0-2.56,2.32,5.64,5.64,0,0,0,.79,5.79,4.31,4.31,0,0,0,7.87-1.65A5.37,5.37,0,0,0,223.65,221.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.63,196.92A21.6,21.6,0,0,1,201,183.37a22,22,0,0,1,2.89-19.83c-4.14,1.06-8.26-2.79-9.11-7s.65-8.57,2.25-12.58c3.66-9.15,8.24-18.33,15.87-24.48s19-8.49,27.24-3.2c.07-3.59,4.28-5.39,7.78-6,15.26-2.52,31.6,1.48,43.62,11.32s19.37,25.49,18.65,41.13c5.18,8.12,1.86,20.46-6.67,24.82a41.62,41.62,0,0,1-5,27.34,40.87,40.87,0,0,1-21.16,17.75",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.16,188.11c.93-13.37,9.9-29.71,23.21-28.21l41.52,10.8a7.85,7.85,0,0,1,7,8L286.71,279l.29.06S277.39,307.26,250,298.5c-5.45-1.74-7.91-7.71-9-13.85l-.28,0c0-.73,0-1.4,0-2.1a65.92,65.92,0,0,1-.1-13.77h0c0-8.1,0-11.42,0-11.34s-17.06-3-20.45-25.26C218.44,221.12,219.12,203,220.16,188.11Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.57,202.29a2.85,2.85,0,0,0,2.74,2.9,2.73,2.73,0,0,0,3-2.56,2.86,2.86,0,0,0-2.73-2.9A2.75,2.75,0,0,0,227.57,202.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,197.58c.35.38,2.53-1.21,5.61-1.18s5.31,1.58,5.65,1.21c.16-.17-.19-.84-1.17-1.56a7.79,7.79,0,0,0-4.52-1.43,7.55,7.55,0,0,0-4.47,1.41C224.18,196.74,223.86,197.42,224,197.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.23,202.8a2.85,2.85,0,0,0,2.74,2.9,2.73,2.73,0,0,0,3-2.56,2.87,2.87,0,0,0-2.73-2.9A2.74,2.74,0,0,0,257.23,202.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.25,198.36c.36.38,2.54-1.21,5.61-1.18s5.32,1.58,5.65,1.21c.17-.17-.19-.84-1.17-1.56a7.77,7.77,0,0,0-4.52-1.43,7.52,7.52,0,0,0-4.46,1.41C254.41,197.52,254.08,198.2,254.25,198.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.94,221.09c0-.17-1.89-.51-5-.93-.78-.09-1.53-.25-1.65-.79a3.89,3.89,0,0,1,.54-2.32c.75-1.9,1.53-3.88,2.36-6,3.28-8.49,5.66-15.48,5.32-15.61s-3.28,6.65-6.56,15.14c-.79,2.1-1.55,4.09-2.27,6a4.58,4.58,0,0,0-.43,3.08,2,2,0,0,0,1.29,1.16,5.31,5.31,0,0,0,1.33.19C241,221.24,242.93,221.27,242.94,221.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.57,257.47a56.64,56.64,0,0,0,29.89-7.76s-7.34,15.26-29.63,13Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.19,228.51a5.55,5.55,0,0,1,5-2,5,5,0,0,1,3.48,1.9,3.21,3.21,0,0,1,.22,3.66,3.74,3.74,0,0,1-4,1,11.72,11.72,0,0,1-3.91-2.38,3.41,3.41,0,0,1-.87-.91,1,1,0,0,1,0-1.15",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,223.28c-.5,0-.53,3.31-3.41,5.66s-6.42,2-6.45,2.42c-.05.21.79.66,2.29.71a8.29,8.29,0,0,0,5.38-1.84,7.19,7.19,0,0,0,2.64-4.74C252.57,224.09,252.2,223.26,252,223.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.91,193c.3.84,3.37.46,7,.92s6.52,1.47,7,.72c.22-.36-.28-1.15-1.45-2a11.84,11.84,0,0,0-5.18-1.85,11.66,11.66,0,0,0-5.47.61C253.45,191.92,252.78,192.57,252.91,193Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.22,188.69c.54.7,2.66,0,5.21,0s4.7.5,5.2-.23c.22-.35-.11-1.05-1-1.72a7.08,7.08,0,0,0-4.22-1.17,7.19,7.19,0,0,0-4.17,1.37C225.29,187.63,225,188.35,225.22,188.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.86,199.73a27.22,27.22,0,0,0-.6-3.92,15.39,15.39,0,0,0-1.8-4.24,16,16,0,0,0-4.08-4.51,15.86,15.86,0,0,0-15.05-2.25,15.07,15.07,0,0,0-4,2.16,14.66,14.66,0,0,0-3.35,3.38,15.77,15.77,0,0,0,0,18.75,14.66,14.66,0,0,0,3.35,3.38,15.07,15.07,0,0,0,4,2.16,16,16,0,0,0,8.34.71,15.79,15.79,0,0,0,6.71-3,16,16,0,0,0,4.08-4.51,15.26,15.26,0,0,0,1.8-4.24,27.44,27.44,0,0,0,.6-3.91,1,1,0,0,1,0,.26c0,.2,0,.45,0,.77a7.57,7.57,0,0,1-.1,1.24,12.93,12.93,0,0,1-.3,1.69,15.5,15.5,0,0,1-1.75,4.34,16.09,16.09,0,0,1-4.1,4.66,16.21,16.21,0,0,1-15.45,2.4,15.35,15.35,0,0,1-4.14-2.21,18.5,18.5,0,0,1-1.86-1.58,17.09,17.09,0,0,1-1.61-1.89,16.26,16.26,0,0,1,0-19.37,17.09,17.09,0,0,1,1.61-1.89,18.5,18.5,0,0,1,1.86-1.58,15.35,15.35,0,0,1,4.14-2.21,16.27,16.27,0,0,1,8.59-.68,16.25,16.25,0,0,1,11,7.74,15.5,15.5,0,0,1,1.75,4.34,13.23,13.23,0,0,1,.3,1.69,7.65,7.65,0,0,1,.1,1.24c0,.32,0,.57,0,.77A1.1,1.1,0,0,1,277.86,199.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.42,188.72a1.12,1.12,0,0,1-.09-.31c-.06-.23-.13-.53-.21-.91s-.19-.91-.35-1.49-.35-1.26-.55-2a48.12,48.12,0,0,0-5.57-12,52.33,52.33,0,0,0-13.47-14.16,58.48,58.48,0,0,0-21.94-9.47,70.49,70.49,0,0,0-24-.8,64.75,64.75,0,0,0-18.88,5.25,46.76,46.76,0,0,0-6.57,3.71,41.81,41.81,0,0,0-4.47,3.54l-1.52,1.43-1,1.13-.64.68a1.53,1.53,0,0,1-.24.23,1.44,1.44,0,0,1,.2-.26l.6-.72,1-1.16,1.49-1.48a40.68,40.68,0,0,1,4.44-3.63,46.37,46.37,0,0,1,6.59-3.8,63.75,63.75,0,0,1,19-5.4,70.2,70.2,0,0,1,24.13.77,58.65,58.65,0,0,1,22.11,9.59A52.19,52.19,0,0,1,297,171.8a46.21,46.21,0,0,1,5.45,12.14l.51,2c.15.59.22,1.1.3,1.51s.12.69.16.92A1.11,1.11,0,0,1,303.42,188.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.83,167.22a.65.65,0,0,1-.05-.23c0-.19,0-.41-.09-.69-.06-.6-.2-1.48-.43-2.61a32.25,32.25,0,0,0-3.42-9.05,42.06,42.06,0,0,0-9.07-11.1,78,78,0,0,0-14.6-9.9,208.22,208.22,0,0,0-29.35-13.08c-3.88-1.38-7.06-2.4-9.26-3.08L240,116.7l-.65-.21c-.15,0-.23-.08-.22-.09s.08,0,.23,0l.67.16c.59.15,1.46.37,2.57.69,2.22.62,5.41,1.58,9.32,2.92a195.12,195.12,0,0,1,29.48,13,77,77,0,0,1,14.67,10,41.83,41.83,0,0,1,9.07,11.28,31.1,31.1,0,0,1,3.3,9.19,23.14,23.14,0,0,1,.34,2.64q0,.42,0,.69A.73.73,0,0,1,308.83,167.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.34,166.25s20.91-.31,36.74,23.29c10.43,15.56,12.63,35.09,12.63,35.09l8.07-37.17-6-17-14.45-8.17-27.42-1.54-10.35,5.12",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.31,168.18c-33.3-8-59.93,3-64.81,29.13l-8.94-14.59,19.49-23.46,19-4.94,38.19,5.81Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.84,165.92a1.29,1.29,0,0,1-.08-.32c0-.24-.09-.55-.16-.94a12.19,12.19,0,0,0-.3-1.52c-.16-.6-.29-1.29-.56-2a28.82,28.82,0,0,0-2.3-5.32,32.58,32.58,0,0,0-4.51-6.19,37.83,37.83,0,0,0-7.09-6,42.26,42.26,0,0,0-9.6-4.6c-7.14-2.43-15.5-3.29-24.19-3.11s-17,1-24.31,2.93a54.38,54.38,0,0,0-10,3.67,42.67,42.67,0,0,0-7.86,4.95,34.7,34.7,0,0,0-8.79,10.12c-.39.7-.73,1.32-1,1.88s-.49,1-.64,1.41-.27.66-.37.89-.13.3-.14.29a23.07,23.07,0,0,1,1.95-4.57,34.05,34.05,0,0,1,8.74-10.3,41.9,41.9,0,0,1,7.9-5,54.36,54.36,0,0,1,10.08-3.76c7.35-2,15.7-2.78,24.43-3s17.15.7,24.35,3.18a42.1,42.1,0,0,1,9.69,4.69,37.46,37.46,0,0,1,7.12,6.1,32.52,32.52,0,0,1,4.5,6.29,28.1,28.1,0,0,1,2.23,5.4,19.42,19.42,0,0,1,.52,2.06,10.1,10.1,0,0,1,.25,1.54c.05.4.09.71.12,1A1.54,1.54,0,0,1,302.84,165.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,188.42a5.86,5.86,0,0,1-1.38-.27,11.92,11.92,0,0,1-3.42-1.74,15.62,15.62,0,0,1-3.82-4.23,22.64,22.64,0,0,1-2.67-6.45,30.32,30.32,0,0,1-.14-12.58,20,20,0,0,1,1.09-3.68c.16-.42.33-.73.43-.94s.18-.32.19-.31a35.06,35.06,0,0,0-1.35,5,32,32,0,0,0,.29,12.39,23.55,23.55,0,0,0,2.56,6.32,15.76,15.76,0,0,0,3.64,4.18A15.07,15.07,0,0,0,219,188.42Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.46,167.31l-.22-.07-.62-.27-1-.44-1.4-.53a40.43,40.43,0,0,0-9.23-2.22,57.18,57.18,0,0,0-14.08.06c-2.64.31-5.39.81-8.23,1.39s-5.75,1.29-8.68,2.2c-11.82,3.42-20.93,10.87-25,17.74a32.29,32.29,0,0,0-3.67,8.73c-.29,1.09-.46,1.94-.58,2.53-.06.26-.1.48-.14.66a1,1,0,0,1-.07.22.58.58,0,0,1,0-.23c0-.18.06-.4.1-.67a24.38,24.38,0,0,1,.49-2.56,30.72,30.72,0,0,1,3.54-8.87c4.08-7,13.28-14.6,25.21-18,3-.91,5.88-1.61,8.73-2.2s5.61-1.07,8.27-1.36a56.19,56.19,0,0,1,14.19,0,38.65,38.65,0,0,1,9.25,2.4l1.39.58,1,.49.6.31C289.4,167.26,289.47,167.3,289.46,167.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.88,167.36a3.36,3.36,0,0,1,.73,0,18.9,18.9,0,0,1,2.06.27,28.91,28.91,0,0,1,7.25,2.42c5.84,2.77,13.13,8.36,18.94,16.37a81.05,81.05,0,0,1,7.05,12,98.58,98.58,0,0,1,4.51,10.4,51.74,51.74,0,0,1,2.13,7.33c.17.89.29,1.58.34,2.05a3.88,3.88,0,0,1,.07.72,3.07,3.07,0,0,1-.17-.7c-.08-.47-.23-1.15-.44-2a60.83,60.83,0,0,0-2.27-7.26,105.82,105.82,0,0,0-4.6-10.3,84.39,84.39,0,0,0-7-11.87,53.83,53.83,0,0,0-18.68-16.34,30.77,30.77,0,0,0-7.13-2.55c-.88-.18-1.56-.31-2-.37A4,4,0,0,1,245.88,167.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.11,199.73a25.52,25.52,0,0,0-.6-3.92,15.39,15.39,0,0,0-1.8-4.24,16,16,0,0,0-4.08-4.51,15.79,15.79,0,0,0-6.71-3,16,16,0,0,0-8.34.71,15.07,15.07,0,0,0-4,2.16,14.66,14.66,0,0,0-3.35,3.38,15.81,15.81,0,0,0,0,18.75,14.66,14.66,0,0,0,3.35,3.38,15.07,15.07,0,0,0,4,2.16,16,16,0,0,0,8.35.71,16.1,16.1,0,0,0,10.78-7.47,15.26,15.26,0,0,0,1.8-4.24,25.7,25.7,0,0,0,.6-3.91.71.71,0,0,1,0,.26c0,.2,0,.45,0,.77A7.57,7.57,0,0,1,240,202a12.93,12.93,0,0,1-.3,1.69A15.5,15.5,0,0,1,238,208a16.09,16.09,0,0,1-4.1,4.66,16.21,16.21,0,0,1-15.45,2.4,15.35,15.35,0,0,1-4.14-2.21,18.5,18.5,0,0,1-1.86-1.58,17.09,17.09,0,0,1-1.61-1.89,16.26,16.26,0,0,1,0-19.37,17.09,17.09,0,0,1,1.61-1.89,18.5,18.5,0,0,1,1.86-1.58,15.35,15.35,0,0,1,4.14-2.21A16.23,16.23,0,0,1,238,191.42a15.5,15.5,0,0,1,1.75,4.34,13.23,13.23,0,0,1,.3,1.69,7.65,7.65,0,0,1,.1,1.24c0,.32,0,.57,0,.77A.8.8,0,0,1,240.11,199.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.39,220a6.38,6.38,0,0,0-2.61-1.64h.2a3.63,3.63,0,0,0-.56-.09,2.53,2.53,0,0,0-2,.3h0a4.79,4.79,0,0,0-2.55,2.32,5.62,5.62,0,0,0,.79,5.79,4.3,4.3,0,0,0,7.86-1.65A5.34,5.34,0,0,0,290.39,220Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.08,178.19a4.55,4.55,0,0,1-1-.5A9.74,9.74,0,0,1,225,177a16.51,16.51,0,0,1-1.36-1,25.52,25.52,0,0,1-3.2-3,29.76,29.76,0,0,1-3.2-4.34,30.41,30.41,0,0,1-2.29-4.89,26.33,26.33,0,0,1-1.12-4.26c-.13-.61-.17-1.18-.23-1.67a9.06,9.06,0,0,1-.09-1.27,4.87,4.87,0,0,1,0-1.09c.1,0,.16,1.54.66,4a30.43,30.43,0,0,0,1.21,4.17,31.74,31.74,0,0,0,2.29,4.78,32.28,32.28,0,0,0,3.11,4.29,30.33,30.33,0,0,0,3.07,3.06C225.8,177.32,227.13,178.1,227.08,178.19Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.53,150.06c.08,0-.56,1.46-1.29,3.86a39,39,0,0,0-1.68,9.6,39.76,39.76,0,0,0,.75,9.73c.51,2.45,1,3.93.93,4a4,4,0,0,1-.43-1,23.73,23.73,0,0,1-.85-2.87,35.16,35.16,0,0,1,.93-19.53A23.1,23.1,0,0,1,228,151,4.53,4.53,0,0,1,228.53,150.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.18,164.71a29.06,29.06,0,0,1-1.31-2.85,50.43,50.43,0,0,0-8.14-12.59,29.36,29.36,0,0,1-2.06-2.36,3,3,0,0,1,.67.52c.42.35,1,.89,1.66,1.59a40.07,40.07,0,0,1,8.21,12.7c.36.9.62,1.64.78,2.16A3.06,3.06,0,0,1,251.18,164.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.78,148.79a6.76,6.76,0,0,1,.61,2.11,24.53,24.53,0,0,1-.34,10.51,7.16,7.16,0,0,1-.74,2.06,58.35,58.35,0,0,0,1-7.31A58.73,58.73,0,0,0,257.78,148.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,152.6a12.53,12.53,0,0,1-2.9,10.53,32.39,32.39,0,0,0,2.16-5.07A32.47,32.47,0,0,0,269,152.6Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.68,193.29c-.1,0,.11-1.73.12-4.51A46.57,46.57,0,0,0,277.51,178a45.82,45.82,0,0,0-3.81-10.13c-1.29-2.46-2.26-3.89-2.19-3.94a5.08,5.08,0,0,1,.75,1,28.38,28.38,0,0,1,1.76,2.81,41.2,41.2,0,0,1,4,10.18,40.77,40.77,0,0,1,1.14,10.87,30,30,0,0,1-.26,3.3A6.18,6.18,0,0,1,278.68,193.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.33,176.51a7,7,0,0,1,.11,1.38c0,.45,0,1,0,1.64s0,1.36-.11,2.16a41.2,41.2,0,0,1-.83,5.57A42.29,42.29,0,0,1,293.37,200a43.63,43.63,0,0,1-3.25,4.6c-.49.63-1,1.16-1.42,1.63s-.81.87-1.13,1.18a7.08,7.08,0,0,1-1,.92,6.9,6.9,0,0,1,.89-1.06c.3-.33.67-.74,1.06-1.23s.88-1,1.35-1.67a45.82,45.82,0,0,0,3.13-4.62,49.85,49.85,0,0,0,3-6.12,49.33,49.33,0,0,0,2.06-6.51,45.66,45.66,0,0,0,.94-5.5c.11-.79.13-1.51.18-2.14s.08-1.17.08-1.62A7.64,7.64,0,0,1,299.33,176.51Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.23,138.18a5.28,5.28,0,0,1,0,2.1,12.81,12.81,0,0,1-5.24,8.45,5.34,5.34,0,0,1-1.87,1c0-.07.66-.46,1.65-1.25a14.63,14.63,0,0,0,5.1-8.23A20.55,20.55,0,0,1,274.23,138.18Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.72,148.8a4.58,4.58,0,0,1-.05,2.07,10.71,10.71,0,0,1-2,4.55,10.54,10.54,0,0,1-3.88,3.14,4.52,4.52,0,0,1-2,.58c0-.08.73-.31,1.82-.91a12,12,0,0,0,3.63-3.13,11.9,11.9,0,0,0,2.09-4.31C293.61,149.59,293.63,148.8,293.72,148.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.72,157.42a4.9,4.9,0,0,1-1.13,1.59,12.54,12.54,0,0,1-8.36,4,4.73,4.73,0,0,1-1.94-.13,19.39,19.39,0,0,0,6.28-1.53A19.63,19.63,0,0,0,300.72,157.42Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.46,146.71a8.56,8.56,0,0,1-1.56-4.89,8.44,8.44,0,0,1,1-5,23.38,23.38,0,0,0-.52,5A24.27,24.27,0,0,0,254.46,146.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.41,147.5c0,.05-.61-.41-1.37-1.31a15.34,15.34,0,0,1-3.4-8.38,5.07,5.07,0,0,1,.06-1.89,30.2,30.2,0,0,0,1.49,6.14A29.36,29.36,0,0,0,251.41,147.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.82,138.18a14.77,14.77,0,0,1-2.16,9.93c-.15-.07.86-2.14,1.45-4.89S233.66,138.18,233.82,138.18Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.77,152.27c0,.06-.48-.09-1.12-.52a7.2,7.2,0,0,1-2-2.2,7.1,7.1,0,0,1-1-2.82c-.08-.76,0-1.24.07-1.23a15.24,15.24,0,0,0,1.36,3.79A14.93,14.93,0,0,0,218.77,152.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.63,113.67c.07.06-1,1.2-2.34,3.35a22.67,22.67,0,0,0-2.2,18.86c.78,2.4,1.59,3.75,1.5,3.8a4.13,4.13,0,0,1-.61-.93,19,19,0,0,1-1.24-2.75A21.63,21.63,0,0,1,224,116.82a19.41,19.41,0,0,1,1.84-2.39C226.31,113.91,226.6,113.64,226.63,113.67Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.48,124.93c.09,0-.22,1.28-.22,3.34a16.84,16.84,0,0,0,7,13.75c1.67,1.21,2.87,1.69,2.83,1.78a2.75,2.75,0,0,1-.86-.29,14,14,0,0,1-2.18-1.19,16.24,16.24,0,0,1-5.45-6.08,16.42,16.42,0,0,1-1.75-8,13.33,13.33,0,0,1,.32-2.46A2.68,2.68,0,0,1,206.48,124.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.13,118.82a2.24,2.24,0,0,1,.35.68,11,11,0,0,1,.65,2,16.59,16.59,0,0,1-2.4,13.13,10.76,10.76,0,0,1-1.31,1.61c-.34.35-.54.53-.57.5s.67-.85,1.57-2.31a18.05,18.05,0,0,0,2.35-12.86C245.45,119.86,245,118.86,245.13,118.82Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.15,122.14a5.72,5.72,0,0,1,.36,2.19,14.77,14.77,0,0,1-3.49,10,6.16,6.16,0,0,1-1.65,1.5,21.46,21.46,0,0,1,1.36-1.73,16.94,16.94,0,0,0,3.41-9.76C255.17,123,255.07,122.15,255.15,122.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.3,127.85c.06,0,.36.4.63,1.19a8,8,0,0,1,.36,3.24,8.1,8.1,0,0,1-1,3.12c-.42.73-.79,1.09-.84,1a15.27,15.27,0,0,0,1.27-4.22A15.38,15.38,0,0,0,271.3,127.85Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.42,138.88c.09.11-.7.92-2,1.46a3.75,3.75,0,0,1-2.4.46,12.44,12.44,0,0,1,2.19-.93A13.3,13.3,0,0,1,288.42,138.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.54,146.88a5.52,5.52,0,0,1,.74,3.54,5.62,5.62,0,0,1-1.11,3.44c-.14-.07.5-1.54.59-3.47S298.39,146.93,298.54,146.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.75,115.67s.2.19.44.6a10.43,10.43,0,0,1,.85,1.83,13,13,0,0,1-2.13,12.65,10.38,10.38,0,0,1-1.41,1.45c-.36.31-.58.45-.61.42s.74-.74,1.73-2.09a13.77,13.77,0,0,0,2.07-12.31C283.21,116.62,282.67,115.71,282.75,115.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.56,126.17a5.26,5.26,0,0,1-.48,2.16,11.47,11.47,0,0,1-7.77,6.87,5.29,5.29,0,0,1-2.2.22c0-.09.83-.17,2.1-.57a12.59,12.59,0,0,0,7.53-6.67C295.3,127,295.47,126.15,295.56,126.17Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305,138.18a2.82,2.82,0,0,1-.26,1.44,8,8,0,0,1-4.93,4.78,3,3,0,0,1-1.44.22,13.24,13.24,0,0,0,4.08-2.43A12.83,12.83,0,0,0,305,138.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.32 284.9 239.09 270.6 287.75 265.8 288.07 272.93 274.93 372.34 285.63 456.22 207.66 456.22 214.32 284.9",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.27,280.76l-1.53-14.31a4.54,4.54,0,0,1,4.1-5l45.38-4.1a2.15,2.15,0,0,1,2.34,2.07l.51,17-13.14,22.3L261.42,303H244.91l-9.5-10.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.37,271a15.37,15.37,0,0,1-1.81-.18,32.53,32.53,0,0,0-4.95-.09,48.89,48.89,0,0,0-7.27,1.05c-2.71.57-5.65,1.37-8.77,2.13a59,59,0,0,1-8.94,1.59,23.32,23.32,0,0,1-7.4-.5,15.86,15.86,0,0,1-4.63-1.92,12.59,12.59,0,0,1-1.1-.8c-.24-.2-.36-.32-.34-.33s.54.36,1.56.94a17.08,17.08,0,0,0,4.6,1.72,23.69,23.69,0,0,0,7.27.37,61.64,61.64,0,0,0,8.84-1.62c3.11-.76,6.07-1.55,8.81-2.09a44.79,44.79,0,0,1,7.35-.94,27.11,27.11,0,0,1,5,.27c.59.1,1,.18,1.34.26A2.54,2.54,0,0,1,281.37,271Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M238.35,273.23c-1.22,3.34-1.25,7.48,1.21,10,2,2.09,5.24,2.61,8.08,2a25.55,25.55,0,0,0,7.89-3.54c6.25-3.72,12.59-7.57,19.69-9.14a2.55,2.55,0,0,0,1.27-.54.83.83,0,0,0,.05-1.22,1.12,1.12,0,0,0-.59-.17c-6.28-.63-12.32,1.85-18.47,3.23s-13.22,2.83-18.85-.49"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M247,261a4.07,4.07,0,0,0-1.56,1.49c-.71,1.15-.62,3.1-.62,5.21.12,4.24.82,7.62.65,7.66a7.73,7.73,0,0,1-.61-2.19,32.92,32.92,0,0,1-.6-5.45,23.1,23.1,0,0,1,.06-3,5.28,5.28,0,0,1,.78-2.41,3.09,3.09,0,0,1,1.28-1.14C246.78,261,247,261,247,261Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259,273.43c-.18,0,.23-3.14-.33-6.92s-1.78-6.68-1.61-6.75a6.26,6.26,0,0,1,.93,1.84,22.21,22.21,0,0,1,1.24,4.83,21.54,21.54,0,0,1,.15,5A6.07,6.07,0,0,1,259,273.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.62,258.56a4.46,4.46,0,0,1,.86,1.69,11.73,11.73,0,0,1-.6,8.95,4.11,4.11,0,0,1-1.08,1.56,18.68,18.68,0,0,0,1.71-6C274.77,261.26,273.44,258.62,273.62,258.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.15,407.39s11-81,14.21-95.69a42.07,42.07,0,0,1,19-26.79l3.05,146.76L204,448.55,189,454.29a15.56,15.56,0,0,1-10.7.17l-14.37-5-1.22-27.38,12.14-3.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.64,283.52a36.06,36.06,0,0,1,22.1,25.67C361.32,347,376,397.31,376.23,413.54c.29,20.67-8.75,34.82-20.55,37.43-6.75,1.49-52.66.74-77.59.21a18.55,18.55,0,0,1-18-16.25h0a18.56,18.56,0,0,1,15.72-20.69l50.51-7.43-9.38-52.41,9.28-72.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.77,267.3,307,275.57l19.24,6.24.46,57.57L315.25,456.07l-40.15.15.08-52.08a303,303,0,0,1,4.88-75l6.11-49.51",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.37,349.1a2.5,2.5,0,0,1,.15.58c.09.45.2,1,.33,1.68.28,1.54.67,3.64,1.13,6.19.93,5.31,2.18,12.51,3.57,20.46s2.52,15.17,3.41,20.48c.4,2.57.73,4.67,1,6.22.1.69.18,1.25.24,1.7a2.1,2.1,0,0,1,0,.6,2.5,2.5,0,0,1-.15-.58c-.1-.45-.21-1-.35-1.68-.28-1.54-.67-3.63-1.15-6.19-.94-5.23-2.21-12.46-3.57-20.46s-2.57-15.23-3.4-20.48c-.4-2.57-.72-4.67-1-6.22-.09-.69-.16-1.25-.22-1.7A2.09,2.09,0,0,1,316.37,349.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.32,291.7a10.49,10.49,0,0,1-1.55.57,38.27,38.27,0,0,0-4.11,1.78,31.9,31.9,0,0,0-11.11,9.47,23.55,23.55,0,0,0-2.19,3.56,23,23,0,0,0-1.31,3.66,36,36,0,0,0-1.1,6.54c-.17,1.88-.2,3.42-.21,4.48a12.55,12.55,0,0,1,0,1.65,7.24,7.24,0,0,1-.18-1.65,40.47,40.47,0,0,1,0-4.51,33.83,33.83,0,0,1,1-6.64,22.62,22.62,0,0,1,1.32-3.77,23.18,23.18,0,0,1,2.23-3.65,30.79,30.79,0,0,1,11.39-9.5,29.21,29.21,0,0,1,4.22-1.63A7.77,7.77,0,0,1,335.32,291.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.65,414.45a3.35,3.35,0,0,0,.7-.05l2-.25,7.38-1,24.32-3.61,17.68-2.72h-.07a12.4,12.4,0,0,1,6.13,2.71,13.27,13.27,0,0,1,3.36,4,15.53,15.53,0,0,1,1.5,4.33,1,1,0,0,0,0-.31c0-.21,0-.51-.12-.9a11.68,11.68,0,0,0-1.12-3.25,13.39,13.39,0,0,0-3.36-4.18,12.73,12.73,0,0,0-6.32-2.88h-.07L309,409l-24.29,3.77-7.35,1.2-2,.36A3.31,3.31,0,0,0,274.65,414.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.71,451.2a1.62,1.62,0,0,0,.48-.16,9.32,9.32,0,0,0,1.33-.6,14.53,14.53,0,0,0,4.17-3.33,19,19,0,0,0,3.79-6.95,22.45,22.45,0,0,0,.73-9.66,18.54,18.54,0,0,0-4-8.83,19.6,19.6,0,0,0-6.11-5,17.66,17.66,0,0,0-5-1.77c-.61-.13-1.11-.13-1.44-.18a1.89,1.89,0,0,0-.5,0,22.16,22.16,0,0,1,6.79,2.31,19.79,19.79,0,0,1,5.89,5,18.31,18.31,0,0,1,3.83,8.58A22.37,22.37,0,0,1,288,440a19,19,0,0,1-3.6,6.84,15.19,15.19,0,0,1-4,3.4C279.34,450.87,278.69,451.14,278.71,451.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "317.12 352.84 309.58 409.15 319.13 407.01 322.09 382.44 317.12 352.84"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162.93,422.09a38.57,38.57,0,0,1,13.72,0,13.74,13.74,0,0,1,9.15,7,15.91,15.91,0,0,1,1.56,10.81c-.65,3.17-1.33,6.45-3.65,8.7-3.42,3.32-6.79,4.39-11.21,3.61L164,449.45Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M170.25,451.64a2.67,2.67,0,0,0,.57.24,10.35,10.35,0,0,0,1.71.46A12.81,12.81,0,0,0,179,452a11.18,11.18,0,0,0,3.92-2.24,14,14,0,0,0,3.13-4.12,19.69,19.69,0,0,0,1.79-5.43,16.18,16.18,0,0,0,.14-6.14,19.05,19.05,0,0,0-2.27-5.7,13.33,13.33,0,0,0-8.58-6.36,23,23,0,0,0-4.47-.5,44.22,44.22,0,0,0-6.46.42l-1.74.25a2,2,0,0,0-.6.13,2.56,2.56,0,0,0,.61,0l1.75-.14a51.29,51.29,0,0,1,6.43-.24,22.85,22.85,0,0,1,4.37.56,13.07,13.07,0,0,1,4.54,2.08c2.89,2,5,5.67,5.87,9.63a15.74,15.74,0,0,1-.13,5.93,19.2,19.2,0,0,1-1.71,5.29,13.54,13.54,0,0,1-3,4,10.94,10.94,0,0,1-3.74,2.21,13.16,13.16,0,0,1-6.3.52C171.07,451.89,170.27,451.59,170.25,451.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M273.41,414.78c4,1.1,8.25,2.34,11,5.46a21,21,0,0,1,1.29,24.68,16.58,16.58,0,0,1-4.94,5.13,10.43,10.43,0,0,1-6.65.93c-6-1-11.12-5.84-12.9-11.7a23,23,0,0,1,2.59-18.41c1.62-2.43,6.82-5.21,9.6-6.09"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M346.71,428.73a7.94,7.94,0,0,1-.43-1.21c-.25-.78-.61-1.91-1.1-3.29A35.84,35.84,0,0,0,340,414.16a20.39,20.39,0,0,0-9-6.69,23.18,23.18,0,0,0-4.6-1,5.06,5.06,0,0,1,1.28,0,13.91,13.91,0,0,1,3.44.67,19.76,19.76,0,0,1,9.26,6.72,33.19,33.19,0,0,1,5.17,10.27c.45,1.41.76,2.56,1,3.36A5,5,0,0,1,346.71,428.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,325.27a4,4,0,0,1,.23.8c.13.58.32,1.36.55,2.34.47,2,1.11,5,1.88,8.61,1.54,7.28,3.53,17.38,5.49,28.57s3.48,21.36,4.49,28.74c.51,3.68.9,6.67,1.15,8.74.11,1,.2,1.79.27,2.38s.07.83.06.84a4.37,4.37,0,0,1-.17-.83c-.09-.58-.21-1.37-.37-2.36-.31-2.11-.75-5.08-1.3-8.72-1.11-7.36-2.7-17.52-4.65-28.7s-3.88-21.29-5.33-28.59c-.72-3.61-1.3-6.55-1.72-8.64-.19-1-.34-1.77-.45-2.35A5.1,5.1,0,0,1,312,325.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.08,284.78c0,.08-1.11.71-2.82,1.94a34.25,34.25,0,0,0-6,5.54,33.62,33.62,0,0,0-4.49,6.84c-.93,1.89-1.37,3.12-1.45,3.09a2.74,2.74,0,0,1,.22-.9,19.62,19.62,0,0,1,.9-2.35,29.31,29.31,0,0,1,4.42-7,30,30,0,0,1,6.21-5.51,19.64,19.64,0,0,1,2.18-1.26A3.12,3.12,0,0,1,329.08,284.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.59,418.44a.9.9,0,0,1,0-.26c0-.19,0-.44,0-.74,0-.69,0-1.65,0-2.86-.05-2.48-.06-6.07-.34-10.49-.15-2.21-.38-4.63-.77-7.2s-1-5.29-1.71-8.13c-1.4-5.68-3.4-11.9-3.82-18.72a60.08,60.08,0,0,1,2.43-18.94c1.51-5.68,3.19-10.7,4.4-15a95.22,95.22,0,0,0,2.42-10.21c.24-1.22.33-2.18.44-2.82,0-.3.08-.54.11-.74s0-.25.06-.24a1.17,1.17,0,0,1,0,.25c0,.2,0,.44-.06.74-.07.65-.13,1.62-.34,2.84A84.76,84.76,0,0,1,209,336.24c-1.16,4.28-2.8,9.31-4.29,15A60.63,60.63,0,0,0,202.37,370c.42,6.74,2.38,12.93,3.77,18.63a79.71,79.71,0,0,1,1.66,8.18c.38,2.59.59,5,.71,7.24.24,4.44.2,8,.18,10.52,0,1.21,0,2.17-.05,2.86l0,.74A.9.9,0,0,1,208.59,418.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.63,302.58l-.32-.08-.9-.28a20.75,20.75,0,0,0-3.55-.7,29.28,29.28,0,0,0-13.08,1.79,51.44,51.44,0,0,0-8.31,3.93c-2.88,1.64-5.85,3.58-9,5.59a85,85,0,0,1-10.23,5.76,35.59,35.59,0,0,1-12.16,3.32,25.82,25.82,0,0,1-12.36-2.36,67.71,67.71,0,0,1-10.17-5.88c-3.1-2.08-6-4.09-8.93-5.69a34.23,34.23,0,0,0-8.48-3.46,22.21,22.21,0,0,0-7.51-.5,17.7,17.7,0,0,0-5.48,1.51,16,16,0,0,0-4,2.78,1.62,1.62,0,0,1,.21-.24c.15-.15.37-.39.67-.67a13.74,13.74,0,0,1,3-2,17.44,17.44,0,0,1,5.54-1.62,22.51,22.51,0,0,1,7.63.43,34.52,34.52,0,0,1,8.6,3.45c2.93,1.59,5.88,3.59,9,5.66a67.68,67.68,0,0,0,10.12,5.81A25.38,25.38,0,0,0,255,321.39a35.12,35.12,0,0,0,12-3.26,84.42,84.42,0,0,0,10.18-5.71c3.16-2,6.14-3.92,9.05-5.56a51.1,51.1,0,0,1,8.4-3.9,28.86,28.86,0,0,1,13.22-1.64,19.55,19.55,0,0,1,3.56.8l.89.33A1.13,1.13,0,0,1,312.63,302.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.85,313.21a8.44,8.44,0,0,1-1,1.14,13.18,13.18,0,0,1-1.29,1.23,20.61,20.61,0,0,1-1.81,1.5,25.38,25.38,0,0,1-2.36,1.61,30.57,30.57,0,0,1-2.87,1.59,35.64,35.64,0,0,1-7.08,2.5,36.07,36.07,0,0,1-7.47.84,30.51,30.51,0,0,1-3.28-.19,24.05,24.05,0,0,1-2.82-.42c-.87-.14-1.62-.39-2.29-.56a14,14,0,0,1-1.69-.55,7.47,7.47,0,0,1-1.39-.59c0-.11,2,.73,5.44,1.33a24,24,0,0,0,2.79.36c1,.13,2.1.11,3.24.14a37.9,37.9,0,0,0,7.35-.87,37.19,37.19,0,0,0,7-2.42c1-.52,2-1,2.86-1.53a26.89,26.89,0,0,0,2.36-1.54C349.33,314.75,350.76,313.13,350.85,313.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.11,332.3a7.62,7.62,0,0,1-2.36.07,22.05,22.05,0,0,1-5.6-1.11,22.49,22.49,0,0,1-5.13-2.5,7.45,7.45,0,0,1-1.84-1.48,41.62,41.62,0,0,0,7.14,3.48A41.2,41.2,0,0,0,208.11,332.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.17,338.55a26.31,26.31,0,0,0-3.58-2.2,24.19,24.19,0,0,0-11.16-2c-4.86.07-10.53,1.35-16.74,3s-13,3.69-20.32,5.06a70.14,70.14,0,0,1-10.79,1.24,64,64,0,0,1-10.11-.48,104,104,0,0,1-16.72-3.62c-4.67-1.38-8.39-2.68-11-3.58l-2.95-1.05-.76-.29c-.17-.07-.26-.11-.25-.12a1.49,1.49,0,0,1,.27.07l.78.24,3,1c2.59.84,6.32,2.08,11,3.42a109,109,0,0,0,16.68,3.5,65.6,65.6,0,0,0,10,.44,72.1,72.1,0,0,0,10.72-1.24c7.28-1.37,14.06-3.42,20.29-5s11.94-2.87,16.85-2.9a23.84,23.84,0,0,1,11.26,2.23l.85.45.72.46a8.14,8.14,0,0,1,1.08.76l.63.52Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.87,450.73s10.45,1.54,14.45,3.16c4.34,1.75,9.7.73,13.34-1.63a37.43,37.43,0,0,0,5.78-4.51l13.36.07a16.05,16.05,0,0,0,3-16.5,18,18,0,0,0-3-5.28c-1.55-1.75-4-3.19-8.34-4l-15.94,3.1s-20.21-.34-28.36-.72a9.21,9.21,0,0,0-5.53,1.53c-1.91,1.27-4.07,3-3.9,4.07.12.81-1.2,6,2.73,9.35,0,0-3.54,2.69-1.71,5.22l.88,1.12s-2.4,3-1.23,4.32,11.57,7.74,15.36,6.34.76-4.94-.89-5.61",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.2,434a8.2,8.2,0,0,1,1.3.49c.82.33,2,.8,3.51,1.32.75.25,1.58.52,2.47.77s1.87.48,2.88.83a6.17,6.17,0,0,1,2.85,1.8,3.58,3.58,0,0,1,.7,3.53,2.81,2.81,0,0,1-1.33,1.37,5.14,5.14,0,0,1-1.76.45,15.05,15.05,0,0,1-3.34-.25,28.53,28.53,0,0,1-5.39-1.53c-1.49-.56-2.67-1.09-3.48-1.45a7.9,7.9,0,0,1-1.24-.62,8.46,8.46,0,0,1,1.31.46c.83.32,2,.8,3.51,1.32a31.26,31.26,0,0,0,5.36,1.42,14.35,14.35,0,0,0,3.23.22,4.61,4.61,0,0,0,1.6-.41,2.26,2.26,0,0,0,1.12-1.16,3.15,3.15,0,0,0-.62-3.08,5.86,5.86,0,0,0-2.65-1.69c-1-.35-1.95-.58-2.85-.86s-1.72-.56-2.47-.83c-1.5-.55-2.68-1.07-3.48-1.46A8.32,8.32,0,0,1,127.2,434Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.3,426.43a10.63,10.63,0,0,1,1.29.5c.82.34,2,.82,3.49,1.35s3.28,1.11,5.29,1.64a7.36,7.36,0,0,1,3.08,1.32,2.63,2.63,0,0,1,.88,1.63,3.33,3.33,0,0,1-.31,1.86,4.48,4.48,0,0,1-2.79,2.27,7.21,7.21,0,0,1-3.34.2,31.68,31.68,0,0,1-5.34-1.67L127,434.22a7.91,7.91,0,0,1-1.27-.54,8.5,8.5,0,0,1,1.33.38l3.55,1.18a34.92,34.92,0,0,0,5.3,1.56,6.92,6.92,0,0,0,3.15-.2,4.1,4.1,0,0,0,2.52-2.06,2.45,2.45,0,0,0-.46-3,7,7,0,0,0-2.89-1.25c-2-.56-3.82-1.17-5.3-1.74s-2.65-1.1-3.45-1.48A7.22,7.22,0,0,1,128.3,426.43Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.25,429.79,161,426s-25.67-12.64-26.12-12-1.85.55-1.61,3.72,15.21,9.85,15.67,11-.46,6.62,5,10.7,9.52,4.26,9.52,4.26",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.49,443.64h-.23a6,6,0,0,1-.64-.08,14,14,0,0,1-2.41-.63,22.12,22.12,0,0,1-3.59-1.65,21.56,21.56,0,0,1-4.23-3.07,11.18,11.18,0,0,1-3.07-5.53,24.85,24.85,0,0,1-.48-3.49,3.73,3.73,0,0,0-.08-.41.78.78,0,0,0-.24-.25,8.21,8.21,0,0,0-.75-.51c-.52-.32-1.07-.63-1.63-.95-2.22-1.24-4.59-2.5-7-3.94-1.19-.72-2.39-1.48-3.55-2.34a13.37,13.37,0,0,1-1.66-1.45,4.65,4.65,0,0,1-.7-.92,2.09,2.09,0,0,1-.2-.58,3.86,3.86,0,0,1,0-.58,4,4,0,0,1,.45-2.24,2.59,2.59,0,0,1,.84-.81,1.63,1.63,0,0,0,.36-.3s0,0,.09-.09a.36.36,0,0,1,.19-.06l.18,0,.28.07c1.4.47,2.67,1.06,4,1.62,2.54,1.13,5,2.27,7.27,3.37,4.61,2.19,8.74,4.21,12.2,5.93.86.42,1.68.85,2.47,1.2l2.26.95,3.63,1.52,2.28,1,.59.27.19.1-.21-.06-.6-.22-2.32-.91-3.66-1.46-2.28-.91c-.8-.35-1.61-.77-2.49-1.19l-12.23-5.84c-2.31-1.08-4.74-2.22-7.28-3.34-1.26-.55-2.56-1.15-3.89-1.59l-.24-.06H135s0,0,0,0,0-.06,0-.1l0,0c.29.2.07.06.13.11l0,0a2.09,2.09,0,0,1-.46.4,2.21,2.21,0,0,0-.71.68,3.78,3.78,0,0,0-.39,2,2,2,0,0,0,.2,1,4.08,4.08,0,0,0,.63.82,13.37,13.37,0,0,0,1.6,1.4c1.14.85,2.33,1.61,3.51,2.32,2.37,1.44,4.73,2.71,7,4,.56.32,1.11.63,1.64,1,.26.17.53.33.78.53a1,1,0,0,1,.36.43,2.29,2.29,0,0,1,.1.48,26,26,0,0,0,.45,3.47,11,11,0,0,0,2.94,5.39,21.86,21.86,0,0,0,4.13,3.08,23.46,23.46,0,0,0,3.53,1.7,16.26,16.26,0,0,0,2.37.71c.27.06.49.09.63.11Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.87,444.25a3.69,3.69,0,0,1,1,.31,10.05,10.05,0,0,1,2.41,1.47,9.21,9.21,0,0,1,1.39,1.4,3,3,0,0,1,.7,2.2,2.41,2.41,0,0,1-1.76,1.83,4.68,4.68,0,0,1-2.72-.14,49,49,0,0,1-8.52-3.64A23.46,23.46,0,0,1,125,446.2a5.07,5.07,0,0,1-.81-.63,5.08,5.08,0,0,1,.9.49c.57.34,1.4.81,2.44,1.35A60.27,60.27,0,0,0,136,450.9a4.35,4.35,0,0,0,2.46.15,2,2,0,0,0,1.5-1.49,2.63,2.63,0,0,0-.61-1.92,9.05,9.05,0,0,0-1.29-1.38A15,15,0,0,0,134.87,444.25Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.93,418.72l-16.48.34s-24.7-8.93-29.78-8.07c-4.58.76-21.33,11.89-24.61,14.1a2,2,0,0,0-.8,1h0a3.58,3.58,0,0,0,2,4.56l.35.15-.15.5a6,6,0,0,0-.26,2,2.42,2.42,0,0,0,4.49,1.05l-.63,1.12a2.73,2.73,0,0,0-.35,1.5l.06,1a2.74,2.74,0,0,0,1.89,2.46h0a2.75,2.75,0,0,0,2.88-.76c2.12-2.33,6.71-7,9.81-7.53a73.35,73.35,0,0,1,10.15-.51,3.43,3.43,0,0,1,3.18,2.2h0c-1.84.13-14.68,6.82-19.22,9.22a4.86,4.86,0,0,0-2.64,3.66c-.17,1.42.55,2.91,3.36,2.25,6-1.41,16.9-6.4,16.9-6.4s5.61-1.6,9.24,1c5.1,3.6,7.44,4.92,11.83,3.47a37.71,37.71,0,0,0,7.62-3.54l14.94,1.45S294.85,430,281.93,418.72Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.78,423.23c0,.1-1.76-.46-4.64-.64a24,24,0,0,0-20,8.52c-1.86,2.21-2.66,3.85-2.74,3.8a4.87,4.87,0,0,1,.55-1.15,21.31,21.31,0,0,1,1.94-2.86,23.25,23.25,0,0,1,20.25-8.64,20.48,20.48,0,0,1,3.41.58A6.78,6.78,0,0,1,243.78,423.23Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.16,417.23a20.56,20.56,0,0,0-4.83-.84,21.1,21.1,0,0,0-11.24,3.18,45.47,45.47,0,0,0-9.06,7.66l-2.48,2.64a8,8,0,0,1-.94.94,5.86,5.86,0,0,1,.81-1.06c.54-.66,1.35-1.6,2.37-2.74a41.87,41.87,0,0,1,9.06-7.84,20.55,20.55,0,0,1,11.49-3.11,13.31,13.31,0,0,1,3.59.66,7.34,7.34,0,0,1,.92.35A1,1,0,0,1,241.16,417.23Z",
    style: {
      fill: "#aa6550"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.43,180.58a61.59,61.59,0,1,0-5,58h0l23.8-.39L175.71,219.5A61.33,61.33,0,0,0,172.43,180.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.43,148.24a7,7,0,0,0-1,.41L87.59,150c-.63.31-1.34.61-2.09,1l-2.4,1.45-2.79,1.71-3,2.26a58.65,58.65,0,0,0-13.08,14,62.71,62.71,0,0,0-9.66,23.39,63.47,63.47,0,0,0,2,30.57,65.64,65.64,0,0,0,3.2,7.85c.66,1.28,1.21,2.63,2,3.87l2.33,3.75a62.1,62.1,0,0,0,12.24,13.51A66.51,66.51,0,0,0,92.8,263.1a65,65,0,0,0,19.53,4.28,59,59,0,0,0,20.58-2.25,39.57,39.57,0,0,0,5-1.68,46.8,46.8,0,0,0,4.93-2,63.53,63.53,0,0,0,9.29-5.47,62.41,62.41,0,0,0,16-16.64l-.56.31,23.34-.59,1.38,0-.86-1.08-15-18.76.13.57a62.29,62.29,0,0,0,.14-28.89,56.31,56.31,0,0,0-4.59-12.79,44,44,0,0,0-3.15-5.74l-1.7-2.72c-.59-.88-1.29-1.68-1.91-2.52a62,62,0,0,0-36.16-22.8A59.29,59.29,0,0,0,113,143l-3.44.22-3.13.5-2.87.47c-.89.2-1.73.46-2.53.67-1.59.46-3,.76-4.2,1.21l-3,1.16L92,148a2.66,2.66,0,0,0-.59.28,2.6,2.6,0,0,0,.64-.18l1.84-.62,3-1.06c1.19-.4,2.62-.68,4.21-1.1a61.68,61.68,0,0,1,63.35,22.48c.61.83,1.29,1.62,1.86,2.48l1.66,2.68a41.94,41.94,0,0,1,3.06,5.65,55.2,55.2,0,0,1,4.46,12.56,61.16,61.16,0,0,1-.23,28.3l-.08.31.21.26q7.26,9.09,15,18.79l.52-1.12-23.35.56h-.36l-.21.31a61.11,61.11,0,0,1-24.71,21.61,45.78,45.78,0,0,1-4.83,2,37.71,37.71,0,0,1-4.91,1.64A57.84,57.84,0,0,1,112.41,266a64.15,64.15,0,0,1-19.11-4.16,65.22,65.22,0,0,1-16.16-9.54,61.1,61.1,0,0,1-12-13.2c-.78-1.23-1.54-2.45-2.3-3.66s-1.3-2.54-2-3.79a63.39,63.39,0,0,1-3.17-7.7,61.23,61.23,0,0,1,7.24-53.16,58.83,58.83,0,0,1,12.77-14l2.9-2.29,2.73-1.75,2.35-1.51c.74-.42,1.44-.74,2-1.06l2.78-1.45A6.1,6.1,0,0,0,91.43,148.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.78,
    y: 174.86,
    width: 10.76,
    height: 61.58,
    rx: 3.6,
    transform: "translate(270.71 411.04) rotate(179.89)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.15,
    y: 174.89,
    width: 10.76,
    height: 61.58,
    rx: 3.6,
    transform: "translate(235.46 411.14) rotate(179.89)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.21,
    y: 174.93,
    width: 10.76,
    height: 61.58,
    rx: 3.6,
    transform: "translate(195.58 411.25) rotate(179.89)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.06,236.44a12.19,12.19,0,0,1-1.34-.25,5.07,5.07,0,0,1-3-2.31,5.14,5.14,0,0,1-.74-2.64c0-1.05,0-2.18,0-3.4,0-2.45,0-5.22,0-8.29,0-6.15,0-13.46,0-21.56,0-4.06,0-8.32,0-12.74v-3.34a12.17,12.17,0,0,1,.21-3.28,5.11,5.11,0,0,1,9.74.27,17.77,17.77,0,0,1,.16,3.3c0,1.12,0,2.24,0,3.34,0,4.42,0,8.68,0,12.74,0,8.11.08,15.41.11,21.57,0,3.06,0,5.84.07,8.28,0,1.22,0,2.37,0,3.39a5,5,0,0,1-.87,2.6,5.21,5.21,0,0,1-3.12,2.14c-.88.19-1.36.14-1.36.18a4.2,4.2,0,0,0,1.39-.05,5.22,5.22,0,0,0,3.3-2.12,5.29,5.29,0,0,0,1-2.73c0-1.06,0-2.18,0-3.41,0-2.44,0-5.22,0-8.28,0-6.16,0-13.46,0-21.57,0-4.06,0-8.32,0-12.74v-5a6.73,6.73,0,0,0-.17-1.77,5.57,5.57,0,0,0-5.4-4.21,5.69,5.69,0,0,0-3.48,1,5.6,5.6,0,0,0-2.12,2.91,6,6,0,0,0-.25,1.78v1.69c0,1.12,0,2.24,0,3.34,0,4.42,0,8.68.05,12.74,0,8.1.08,15.41.11,21.57,0,3.06.05,5.83.06,8.28,0,1.22,0,2.35,0,3.4a5.3,5.3,0,0,0,.83,2.78,5.13,5.13,0,0,0,3.18,2.3A4,4,0,0,0,135.06,236.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.44,236.47a13.19,13.19,0,0,1-1.35-.24,5.16,5.16,0,0,1-3.73-5c0-1.05,0-2.18,0-3.4,0-2.44,0-5.22,0-8.28,0-6.16,0-13.46,0-21.57V181.94a11.68,11.68,0,0,1,.21-3.27,5.1,5.1,0,0,1,9.74.26,17,17,0,0,1,.15,3.3c0,1.13,0,2.24,0,3.35,0,4.41,0,8.67,0,12.73,0,8.11.08,15.42.11,21.57,0,3.07,0,5.84.06,8.29,0,1.21,0,2.36,0,3.39a5,5,0,0,1-.87,2.6,5.3,5.3,0,0,1-3.13,2.14c-.87.18-1.36.13-1.35.17a4.25,4.25,0,0,0,1.38,0,5.31,5.31,0,0,0,3.31-2.13,5.19,5.19,0,0,0,1-2.72c.05-1.07,0-2.19,0-3.41,0-2.45,0-5.23,0-8.29,0-6.15,0-13.46,0-21.57,0-4.06,0-8.32,0-12.74v-3.34c0-.56,0-1.12,0-1.69a6.36,6.36,0,0,0-.17-1.77,5.56,5.56,0,0,0-5.39-4.21,5.59,5.59,0,0,0-5.61,3.91,6.06,6.06,0,0,0-.24,1.78v1.69c0,1.13,0,2.24,0,3.35,0,4.41,0,8.67,0,12.73,0,8.11.08,15.41.12,21.57,0,3.06,0,5.84.06,8.28,0,1.22,0,2.36,0,3.4a5.3,5.3,0,0,0,.82,2.78,5.17,5.17,0,0,0,3.19,2.3A3.72,3.72,0,0,0,117.44,236.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5,236.51a12.06,12.06,0,0,1-1.35-.25,5.16,5.16,0,0,1-3.73-4.95c0-1.05,0-2.18,0-3.4,0-2.45,0-5.22,0-8.28,0-6.16,0-13.46,0-21.57V182a11.68,11.68,0,0,1,.21-3.27,5.1,5.1,0,0,1,9.74.26,17,17,0,0,1,.15,3.3c0,1.12,0,2.24,0,3.34,0,4.42,0,8.68,0,12.74,0,8.11.08,15.42.11,21.57,0,3.06,0,5.84.06,8.29,0,1.21,0,2.36,0,3.38a5,5,0,0,1-.87,2.6,5.29,5.29,0,0,1-3.13,2.15c-.87.18-1.36.13-1.35.17a4.25,4.25,0,0,0,1.38,0,5.33,5.33,0,0,0,4.29-4.86c0-1.06,0-2.18,0-3.4,0-2.45,0-5.23,0-8.29,0-6.16,0-13.46,0-21.57,0-4.06,0-8.32,0-12.74v-5a7.22,7.22,0,0,0-.17-1.77,5.58,5.58,0,0,0-5.4-4.21,5.59,5.59,0,0,0-5.61,3.91,6.41,6.41,0,0,0-.24,1.78V182c0,1.13,0,2.24,0,3.34,0,4.42,0,8.68,0,12.74,0,8.11.08,15.41.12,21.57,0,3.06,0,5.84.06,8.28,0,1.22,0,2.35,0,3.4a5.3,5.3,0,0,0,.82,2.78,5.17,5.17,0,0,0,3.19,2.3A3.72,3.72,0,0,0,97.5,236.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.06,187a7.56,7.56,0,1,1-7.57-7.54A7.56,7.56,0,0,1,125.06,187Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.15,205.71a7.56,7.56,0,1,1-7.57-7.55A7.56,7.56,0,0,1,105.15,205.71Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.85,
    cy: 217.08,
    r: 7.56,
    transform: "translate(-116.6 262.71) rotate(-68.44)",
    style: {
      fill: "#FF725E"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.68,456.32H230.51L211.05,350.46a7.91,7.91,0,0,0-7.78-6.48H67.74a7.91,7.91,0,0,0-7.77,9.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.51,456.32h57.21l-.23-.17A30.9,30.9,0,0,0,269.85,450l-40.91-1.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.28,344.12s.42-.07,1.22-.08a7.59,7.59,0,0,1,3.35.83,10.33,10.33,0,0,1,4,3.66,19.41,19.41,0,0,1,2.47,6.84c.49,2.68.92,5.65,1.46,8.82s1.12,6.56,1.79,10.12c1.32,7.11,2.87,14.91,4.57,23.09,3.4,16.35,6.55,31.13,8.62,41.87,1,5.37,1.83,9.72,2.38,12.73.26,1.48.47,2.64.63,3.47.07.37.13.66.17.9a1.9,1.9,0,0,0,.08.3.91.91,0,0,0,0-.31c0-.24-.07-.54-.12-.91-.13-.84-.3-2-.53-3.48-.47-3-1.21-7.39-2.2-12.77-2-10.77-5.06-25.57-8.46-41.92-1.69-8.17-3.27-16-4.61-23.07-.68-3.55-1.28-6.93-1.84-10.1s-1-6.12-1.53-8.82a19.64,19.64,0,0,0-2.59-6.93,10.52,10.52,0,0,0-4.19-3.69,7.23,7.23,0,0,0-3.45-.74A4.56,4.56,0,0,0,194.28,344.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 137.88,
    cy: 397.77,
    r: 7.29,
    transform: "translate(-240.88 214) rotate(-45)",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.21,456.22c0,.14-97.54.26-217.83.26s-217.85-.12-217.85-.26S138,456,258.38,456,476.21,456.08,476.21,456.22Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.e228a43d1a5a789627fb55397b8f288f.svg";
export { ForwardRef as ReactComponent };